module.exports = __webpack_public_path__ + "img/photo-8-1.4ba19b50.webp";